export default __webpack_public_path__ + "static/media/shutterstock_489519301.79d72cfa.png";